import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconAnimation, IconBeachAccess, IconFitnessCenter, IconHotelFront, IconLeaf, IconPersonPlay, IconPool, IconRestaurant, IconRoom, IconSailing, IconSpa } from '@travel-frontend/icons';
const iconMapping = {
  type: IconHotelFront,
  hotel: IconHotelFront,
  wellness: IconSpa,
  children: IconPersonPlay,
  eco: IconLeaf,
  pool: IconPool,
  beach: IconBeachAccess,
  sports: IconFitnessCenter,
  'water sports': IconSailing,
  'restaurants/food': IconRestaurant,
  animation: IconAnimation,
  near: IconRoom
};
export const SectionIcon = /*#__PURE__*/_styled(({
  name,
  ...restProps
}) => {
  const Icon = iconMapping[name] ?? null;
  if (!Icon) {
    return null;
  }
  return _jsx(Icon, {
    ...restProps
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1exbiy40"
} : {
  target: "e1exbiy40",
  label: "SectionIcon"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY3Rpb25JY29uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCRyIsImZpbGUiOiJTZWN0aW9uSWNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBJY29uQW5pbWF0aW9uLCBJY29uQmVhY2hBY2Nlc3MsIEljb25GaXRuZXNzQ2VudGVyLCBJY29uSG90ZWxGcm9udCwgSWNvbkxlYWYsIEljb25QZXJzb25QbGF5LCBJY29uUG9vbCwgSWNvblJlc3RhdXJhbnQsIEljb25Sb29tLCBJY29uU2FpbGluZywgSWNvblNwYSwgfSBmcm9tICdAdHJhdmVsLWZyb250ZW5kL2ljb25zJztcbmNvbnN0IGljb25NYXBwaW5nID0ge1xuICAgIHR5cGU6IEljb25Ib3RlbEZyb250LFxuICAgIGhvdGVsOiBJY29uSG90ZWxGcm9udCxcbiAgICB3ZWxsbmVzczogSWNvblNwYSxcbiAgICBjaGlsZHJlbjogSWNvblBlcnNvblBsYXksXG4gICAgZWNvOiBJY29uTGVhZixcbiAgICBwb29sOiBJY29uUG9vbCxcbiAgICBiZWFjaDogSWNvbkJlYWNoQWNjZXNzLFxuICAgIHNwb3J0czogSWNvbkZpdG5lc3NDZW50ZXIsXG4gICAgJ3dhdGVyIHNwb3J0cyc6IEljb25TYWlsaW5nLFxuICAgICdyZXN0YXVyYW50cy9mb29kJzogSWNvblJlc3RhdXJhbnQsXG4gICAgYW5pbWF0aW9uOiBJY29uQW5pbWF0aW9uLFxuICAgIG5lYXI6IEljb25Sb29tLFxufTtcbmV4cG9ydCBjb25zdCBTZWN0aW9uSWNvbiA9IHN0eWxlZCgoeyBuYW1lLCAuLi5yZXN0UHJvcHMgfSkgPT4ge1xuICAgIGNvbnN0IEljb24gPSBpY29uTWFwcGluZ1tuYW1lXSA/PyBudWxsO1xuICAgIGlmICghSWNvbikge1xuICAgICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG4gICAgcmV0dXJuIF9qc3goSWNvbiwgeyAuLi5yZXN0UHJvcHMgfSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVNlY3Rpb25JY29uLmpzLm1hcCJdfQ== */");